import React from 'react';
import { useGoals } from '../../contexts/GoalsContext';
import { dateKey, ayahsReadOn } from '../../utils/readingLog';

const WEEKS = 18;
const DAYS = WEEKS * 7;

// Reading history as a grid, one square per day, the most recent at the right.
const StreakCalendar = () => {
  const { log, now } = useGoals();

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  // Start on the Monday that keeps today in the final column
  const start = new Date(today);
  start.setDate(start.getDate() - (DAYS - 1) - ((today.getDay() + 6) % 7) + 6);

  const days = [];
  let busiest = 1;
  for (let index = 0; index < DAYS; index += 1) {
    const date = new Date(start);
    date.setDate(date.getDate() + index);
    const count = ayahsReadOn(log, dateKey(date)).length;
    if (count > busiest) busiest = count;
    days.push({ date, count, future: date > today });
  }

  const shade = (count) => {
    if (count === 0) return 'var(--color-light-gray)';
    // Built on the heading colour, not medium-green: the dark themes map
    // medium-green close to their own background, which would collapse every
    // step onto the same near-black square.
    const step = Math.ceil((count / busiest) * 4);
    return `color-mix(in srgb, var(--color-heading) ${step * 25}%, var(--color-light-gray))`;
  };

  return (
    <div>
      <div className="grid grid-flow-col gap-1" style={{ gridTemplateRows: 'repeat(7, minmax(0, 1fr))' }}>
        {days.map(({ date, count, future }) => (
          <div
            key={date.toISOString()}
            title={`${dateKey(date)} — ${count} verse${count === 1 ? '' : 's'}`}
            className="rounded-sm"
            style={{
              aspectRatio: '1 / 1',
              backgroundColor: future ? 'transparent' : shade(count),
              opacity: future ? 0 : 1
            }}
          />
        ))}
      </div>
      <p className="text-xs mt-2 font-lato" style={{ color: 'var(--color-charcoal)', opacity: 0.6 }}>
        Last {WEEKS} weeks — darker means more verses that day
      </p>
    </div>
  );
};

export default StreakCalendar;
